module.exports = __webpack_public_path__ + "static/media/progressdanger.e265a765.svg";